import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ScrollArea } from '@/components/ui/scroll-area';
import { cn } from '@/lib/utils';
import { MessageSquare } from 'lucide-react';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ChatMessage } from './ChatMessage';
export function ChatMessageList({ messages, className, }) {
    const { t } = useTranslation();
    const bottomRef = useRef(null);
    useEffect(() => {
        bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messages]);
    if (messages.length === 0) {
        return (_jsxs("div", { className: cn('flex min-h-0 min-w-0 flex-1 flex-col items-center justify-center gap-3 px-6 text-center', className), children: [_jsx(MessageSquare, { className: "text-muted-foreground/30 h-8 w-8" }), _jsx("p", { className: "text-muted-foreground/60 text-sm", children: t('chat.emptyState') })] }));
    }
    return (_jsx(ScrollArea, { className: cn('min-h-0 min-w-0', className), children: _jsxs("div", { className: "min-w-0 space-y-4 p-4", children: [messages.map((msg) => (_jsx(ChatMessage, { message: msg }, msg.id))), _jsx("div", { ref: bottomRef })] }) }));
}
